import http from "./request";

//banner列表
const getBannerList = (data) => {
  return http.get("/web/index", data);
};
//关于我们
const getAboutus = (data) => {
  return http.get("/web/aboutus", data);
};
//相关疾病列表
const getillnessList = (data) => {
  return http.get("/web/illness", data);
};
//产品介绍列表
const getProductList = (data) => {
  return http.get("/web/products", data);
};
//相关疾病或产品介绍详情
const getDetail = (data) => {
  return http.get("/web/illnessProducts/detail", data);
};
//新闻咨询列表
const getNewsList = (data) => {
  return http.get("/web/news", data);
};
//新闻咨询详情
const getNewsDetail = (data) => {
  return http.get("/web/news/detail", data);
};
//人才招聘列表
const getRecruitList = (data) => {
  return http.get("/web/recruit", data);
};

//banner列表
const getBannersImage = (data) => {
  return http.get("/web/banners", data);
};
export default {
  getBannerList,
  getAboutus,
  getillnessList,
  getProductList,
  getDetail,
  getNewsList,
  getNewsDetail,
  getRecruitList,
  getBannersImage,
};
